import * as React from "react";
import { Table } from "antd";
import { connect } from "react-redux";
import AfterSale from "widget/tag/afterSale";
import Peikuan from "widget/tag/peikuan";

interface IAftersaleProps {
  number: any;
  afterlist: any;
  user: any;
  id: any;
  tabStatus: any;
}

// 修改
class Aftersale extends React.Component<IAftersaleProps, any> {
  state = {
    lmafterlist: [],
    supplier_after_sale: [],
    merge_order: [],
    lmAmount: '',
    supplierAmount: '',
    customerAmount: '',
    refresh: true,
  };
  constructor(props: IAftersaleProps) {
    super(props);
  }

  componentDidMount() {
    this.afterlist();
  }

  shouldComponentUpdate(nextProps: any, prevState: any) {
    if (nextProps.tabStatus != 'tab3' && !prevState.refresh) {
      this.setState({
        refresh: true,
      });
      return true;
    }
    if (nextProps.tabStatus == 'tab3' && prevState.refresh) {
      this.afterlist();
      return false;
    }
    return true;
  }

  afterlist = () => {
    this.setState({
      refresh: false,
    });
    const param: any = {
      id: this.props.id
    };
    this.props.afterlist({
      ...param,
      callback: (data) => {
        this.setState({
          lmafterlist: data.orderList,
          lmAmount: data.lmAmount,
          supplierAmount: data.supplierAmount,
          customerAmount: data.customerAmount,
          supplier_after_sale: data.supplier_after_sale,
          merge_order: data.merge_order,
        });
      }
    });
  }



  decodeBase64Content = (base64Content) => {
    let commonContent = base64Content.replace(/\s/g, '+');
    commonContent = Buffer.from(commonContent, 'base64').toString();
    return commonContent;
  }

  render() {
    const dataSource = this.state.lmafterlist;
    const dataSourcesupplier = this.state.supplier_after_sale;
    const dataSourcemerge = this.state.merge_order;
    const suppliercolumns = [{
      title: '供应商售后编号',
      dataIndex: 'number',
      key: 'numbers',
    }, {
      title: '售后状态',
      dataIndex: 'status',
      key: 'status',
      className: 'th',
    }, {
      title: '供应商',
      dataIndex: 'supplier_code',
      key: 'supplier_code',
      className: 'th',
    }, {
      title: '售后编号',
      dataIndex: 'lm_number',
      key: 'lm_number',
      className: 'th',
    }, {
      title: '团号',
      dataIndex: 'group_number',
      key: 'group_number',
      className: 'th',
    }, {
      title: '申请日期',
      dataIndex: 'apply_time',
      key: 'apply_time',
      className: 'th',
    }, {
      title: '申请人',
      dataIndex: 'apply_person',
      key: 'apply_person',
      className: 'th',
    }, {
      title: '供应商核实人',
      dataIndex: 'verify_person',
      key: 'verify_person',
      className: 'th',
    }, {
      title: '金额(￥)',
      dataIndex: 'amount',
      key: 'amount',
      className: 'th',
    }, {
      title: '赔款换算金额',
      dataIndex: 'exchange_money',
      key: 'exchange_money',
      className: 'th',
      render: (text, row, index) => {
        return (
          <React.Fragment>
            <span>{row.exchange_money}{row.exchange_amoun}</span>
          </React.Fragment>
        );
      }
    }, {
      title: '售后原因',
      dataIndex: 'reson',
      key: 'reson',
      className: 'th',
    }, {
      title: '描述',
      dataIndex: 'apply_desc',
      key: 'apply_desc',
      className: 'th',
    }, {
      title: '处理日期',
      dataIndex: 'deal_time',
      key: 'deal_time',
      className: 'th',
    }, {
      title: '出行日期',
      dataIndex: 'go_time',
      key: 'go_time',
      className: 'th',
    }, {
      title: '操作人',
      dataIndex: 'deal_person',
      key: 'deal_person',
      className: 'th',
    }, {
      title: '备注',
      dataIndex: 'lm_remark',
      key: 'lm_remark',
      className: 'th',
    }];
    const columns = [{
      title: '售后编号',
      dataIndex: 'number',
      key: 'number',
      className: 'th',
      width: 200,
      render: (text, row, index) => {
        return (
          <React.Fragment>
            <a href={row.url}>{row.number}</a>
          </React.Fragment>
        );
      }
    }, {
      title: '售后状态',
      dataIndex: 'solution_type',
      key: 'solution_type',
      className: 'th',
      width: 100,
    }, {
      title: '负责人',
      dataIndex: 'signer',
      key: 'signer',
      className: 'thl',
      width: 200,
      render: (text, row, index) => {
        return (
          <React.Fragment>
            <p><strong>指派给：</strong>{row.signer}</p>
            <p><strong>创建人：</strong>{row.creator}</p>
            <p><strong>解决人：</strong>{row.solution_person}</p>
          </React.Fragment>
        );
      }
    }, {
      title: '日期',
      dataIndex: 'create_time',
      key: 'create_time',
      className: 'th',
      width: 130,
    }, {
      title: '售后类型',
      dataIndex: 'type',
      key: 'type',
      className: 'th',
    }, {
      title: '售后原因',
      dataIndex: 'resion',
      key: 'resion',
      className: 'th',
    }, {
      title: '解决方法',
      key: 'solutionMethod',
      dataIndex: 'solutionMethod',
      className: 'th',
    }, {
      title: '退款/赔款金额 (￥)',
      dataIndex: 'amount',
      width: 120,
      key: 'amount',
      className: 'th',
      render: (text, row, index) => {
        return (
          <React.Fragment>
            <span>{row.amount}/{row.reparation_amount}</span>
          </React.Fragment>
        );
      }
    }, {
      title: '懒猫赔付(￥)',
      dataIndex: 'lm_amount',
      key: 'lm_amount',
      width: 90,
      className: 'th',
    }, {
      title: '供应商赔付(￥)',
      dataIndex: 'sp_amount',
      key: 'sp_amount',
      width: 110,
      className: 'th',
    }, {
      title: '客服赔付(￥)',
      dataIndex: 'cu_amount',
      key: 'cu_amount',
      width: 90,
      className: 'th',
    }];


    return (
      <React.Fragment>
        <div className="from-after">
          <div className="after-head">
            <div className='ahead-left'>
              订单<span className="colour-blue">{this.decodeBase64Content(this.props.number)}</span>的售后记录 <AfterSale orderNo={[this.props.id]} type="after" pfn={this.afterlist} />
            </div>
            <div className='ahead-right'>
              <span>懒猫赔付总计：<label>￥{this.state.lmAmount}</label></span><span>供应商赔付总计：<label>￥{this.state.supplierAmount}</label></span><span>客服赔付总计：<label>￥{this.state.customerAmount}</label></span>
            </div>
          </div>
          <div className="table1">
            <Table bordered={true} expandIconAsCell={false} expandIconColumnIndex={-1} pagination={false} dataSource={dataSource} columns={columns} />
          </div>
          <div className="table2">
            <h3>订单<span className="colour-blue">{this.decodeBase64Content(this.props.number)}</span>的供应商售后记录
                  <Peikuan pfn={this.afterlist} />
            </h3>
            <Table bordered={true} expandIconAsCell={false} expandIconColumnIndex={-1} pagination={false} dataSource={dataSourcesupplier} columns={suppliercolumns} />
          </div>
          <div className="table3">
            <h3>订单<span className="colour-blue">{this.decodeBase64Content(this.props.number)}</span>的合并订单售后记录</h3>
            <Table bordered={true} expandIconAsCell={false} expandIconColumnIndex={-1} pagination={false} dataSource={dataSourcemerge} columns={columns} />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  number: state.orderDetails.number,
  id: state.orderDetails.id,
  user: state.userInfo.user,
  tabStatus: state.orderDetails.tabStatus,
});

const mapDispatch = dispatch => {
  return {
    afterlist: dispatch.orderDetails.afterlist
  };
};


export default connect(
  mapState,
  mapDispatch
)(Aftersale);
